import React from "react";
import { Mixpanel } from "../../redux/Mixpanel";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {Row, Col} from 'reactstrap';
import store from "../../redux/store";
import {
    deleteProperty,
    showLoading,
    deleteUnit,
    fetchTeam,
    fetchCurrency,
    fetchOptions
} from '../../redux/actions';
import {
    IonButton, IonCheckbox,
    IonContent, IonHeader, IonIcon, IonPage,
    IonTitle, IonToolbar,
    IonList, IonItem,
    IonModal, IonButtons,
    IonFab, IonFabButton, IonFabList, IonMenuButton, IonSelect, IonSelectOption
} from '@ionic/react';
import {
    add,
    business,
    optionsOutline,
    home
} from 'ionicons/icons';
import _ from 'lodash';
import { getPropertiesSummary } from "../../utils";
import IonCustomPropertySelect from '../../components/IonCustomPropertySelect';
import { PAYBILL, TILL_NUMBER } from "../../utils/constants";
import PropertyListItem from "./PropertyListItem";
import { PropertyForm, UnitsForm } from "../Forms";
import { fetchPropertiesUnitsTenants } from "../../redux/middleware";
import UnitsListItem from "./UnitsListItem";
import PropertiesSummaryCard from "./PropertyTransactionsSummaryCards";
import * as PermChecker from "../../utils/PermUtils";
import { colorTheme } from "../../utils/constants";

const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        unitsOrder: state.unitsOrder,
        tenants: state.tenants,
        options: state.options,
        currency: state.currency
    };
}

const mapDispatchToProps = {
    deleteProperty,
    deleteUnit,
    fetchTeam,
    showLoading,
    fetchCurrency,
    fetchOptions
};

const PROPERTIES_FORM_PAGE = "propertiesForm";
const UNITS_FORM_PAGE = "unitsForm";
const PROPERTIES_PAGE = "properties";
const UNITS_PAGE = "units";
const PAGE_FILTERS = "filters";

class Properties extends React.Component{
    constructor(props){
        super(props);
        this.onClickAddProperty = this.onClickAddProperty.bind(this);
        this.handleSelectPropertyAction = this.handleSelectPropertyAction.bind(this);
        this.handleSelectProperty = this.handleSelectProperty.bind(this);
        let propertiesSummary = getPropertiesSummary(Object.keys(this.props.properties), this.props.properties);

        this.state = {
            page: this.props.tab === 'properties' ? PROPERTIES_PAGE :  UNITS_PAGE,
            propertyId: "",
            unitId: "",
            selectedUnits: [],
            propertyToEdit: null,
            unitToEdit:  null,
            propertiesSummary,
            singlePropertySummary: getPropertiesSummary([], {}),
            selectedPropertiesData: [],
            selectedUnitsPage: [],
            isVacantUnitsChecked: false,
            userAllPerms: {},
        };
    }

    fetchInitialData = async () => {
        if (_.isEmpty(this.props.currency)) {
            this.props.showLoading(true);
            await this.props.fetchCurrency();
        }

        if (_.isEmpty(this.props.properties) || _.isEmpty(this.props.units)) {
            this.props.showLoading(true);
            await store.dispatch(fetchPropertiesUnitsTenants);
            await this.props.fetchTeam();
        }
        if (_.isEmpty(this.props.options)) {
            this.props.showLoading(true);
            await this.props.fetchOptions();
        }
    }

    async componentDidMount(){
        await this.fetchInitialData();
        const propertiesIds = Object.keys(this.props.properties);
        let propertiesSummary = getPropertiesSummary(propertiesIds, this.props.properties);
        let propertyId = "";
        let allProperties = propertiesIds.length;
        if(allProperties === 1){
            propertyId = propertiesIds[0];
        }
        let selectedPropertiesData = Object.values(this.props.properties);
        let selectedUnits = this.getUnitsOrder(Object.values(this.props.units));
        let selectedUnitsPage = this.state.unitId !== "" && this.props.units && this.props.units[this.state.unitId]? [this.props.units[this.state.unitId]] : selectedUnits;
        const hasAllUnitPerms = PermChecker.checkUserHasPermission(PermChecker.UNIT_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllPropertyPerms = PermChecker.checkUserHasPermission(PermChecker.PROPERTY_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        this.setState({
            propertiesSummary,
            selectedPropertiesData,
            propertyId,
            userAllPerms: {
                property: hasAllPropertyPerms,
                unit: hasAllUnitPerms
            },
            selectedUnits,
            selectedUnitsPage
        });
        this.selectedProperty(propertyId);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.properties !== prevProps.properties){
            this.selectedProperty(this.state.propertyId);
        }

        if (this.props.properties !== prevProps.properties
            ||this.state.page !== prevState.page){
                const propertiesIds = Object.keys(this.props.properties);
            let selectedPropertiesData = Object.values(this.props.properties);
            let propertiesSummary = getPropertiesSummary(propertiesIds, this.props.properties);

            this.setState({
                propertiesSummary,
                selectedPropertiesData,
            });
        }

        if ( this.state.propertyId !== prevState.propertyId || this.state.unitId !== prevState.unitId){
            this.setState((state) => {
                let selectedUnits = state.selectedUnits;
                selectedUnits = this.getUnitsOrder(selectedUnits);  // ordered selected units
                let selectedUnitsPage = this.state.unitId !== "" && this.props.units && this.props.units[this.state.unitId]? [this.props.units[state.unitId]] : selectedUnits;
                return {
                    selectedUnitsPage,
                    selectedUnits
                }
            });
        }

        if (this.props.units !== prevProps.units){
            this.setState((state) => {
                let selectedUnits;
                if (state.propertyId){
                    selectedUnits = [];
                    for (let unit of Object.values(this.props.units)){
                        if (unit.propertyId == state.propertyId){
                            selectedUnits.push(unit)
                        }
                    }
                }else{
                    selectedUnits = Object.values(this.props.units);
                }
                selectedUnits = this.getUnitsOrder(selectedUnits);  // ordered selected units
                let selectedUnitsPage = this.state.unitId !== "" && this.props.units && this.props.units[this.state.unitId]? [this.props.units[state.unitId]] : selectedUnits;
                return {
                    selectedUnits,
                    selectedUnitsPage
                }
            });
        }
    }

    // get ordered unit records before paginating
    getUnitsOrder(selectedUnits) {
        let order = this.props.unitsOrder;
        let orderedRecords = [];
        let selectedUnitsObj = {};

        for (let unit of selectedUnits){
            selectedUnitsObj[unit.unitId] = unit
        }
        // only order the selected units
        for (let id of order) {
            if (selectedUnitsObj.hasOwnProperty(id)) {
                orderedRecords.push(selectedUnitsObj[id]);
            }
        }
        return orderedRecords;

    }

    selectedProperty(propertyID){
        let value = propertyID;
        let singlePropertySummary = getPropertiesSummary([value], this.props.properties);
        this.setState((prevState) => {
            let state = {};
            if (value != ""){

                let selected = [];
                for (let unit of Object.values(this.props.units)){
                    if (unit.propertyId == value){
                        selected.push(unit)
                    }
                }
                state["selectedUnits"] = selected;
            } else {
                state["selectedUnits"] = Object.values(this.props.units);
            }
            state["propertyId"] = value;
            state["unitId"] = "";
            // state["singlePropertySummary"] = singlePropertySummary;
            return state;
        });
    }

    handleSelectProperty(event){
        let value = event.target.value;

        // let singlePropertySummary = getPropertiesSummary([value], this.props.properties);
        this.setState((prevState) => {
            let state = {};
            if (value != ""){

                let selected = [];
                for (let unit of Object.values(this.props.units)){
                    if (unit.propertyId == value){
                        selected.push(unit)
                    }
                }
                state["selectedUnits"] = selected;
            }else{
                state["selectedUnits"] = Object.values(this.props.units);
            }
            state["propertyId"] = value;
            state["unitId"] = "";
            state["isVacantUnitsChecked"] = false;
            // state["singlePropertySummary"] = singlePropertySummary;
            return state;
        });
    }

    handleSelectPropertyAction(action, propertyId){

        if (action === 'edit'){
            let property = this.props.properties[propertyId];
            this.setState({
                propertyToEdit: property,
                page: PROPERTIES_FORM_PAGE
            });

        }else if(action === 'delete'){
            if(confirm(`Are you sure you want to delete this property '${this.props.properties[propertyId]?.propertyName}'?`)){
                this.props.showLoading(true);
                this.props.deleteProperty(propertyId);
            }
        }
    }

    handleSelectUnit(event){
        event.preventDefault();
        let unitId = event.target.value;

        if (unitId == ""){
            this.setState((prevState) => {
                // let singlePropertySummary = getPropertiesSummary([prevState.propertyId], this.props.properties);
                let selected = [];
                for (let unit of Object.values(this.props.units)){
                    if (unit.propertyId == prevState.propertyId){
                        selected.push(unit)
                    }
                }

                return ({
                    unitId,
                    selectedUnits: selected,
                    // singlePropertySummary
                })
        });

        }else{
            this.setState(prevState => {
                let filtered_units = [this.props.units[unitId]] || [];
                // let singlePropertySummary = getPropertiesSummary([prevState.propertyId], this.props.properties);
                return ({
                    unitId,
                    selectedUnitsPage: filtered_units,
                    // singlePropertySummary
                });
            });
        }
    }


    onClickAddProperty(event){
        event.preventDefault();
        this.setState({
            page: PROPERTIES_FORM_PAGE
        });
        Mixpanel.track("Properties page: Add property btn");
    }


    handleSelectEditProperty(property, event){
        event.preventDefault();
        this.setState({
            propertyToEdit: property,
            page: PROPERTIES_FORM_PAGE
        });
    }

    handleSelectEditUnit(unit, event){
        event.preventDefault();
        this.setState({
            unitToEdit: unit,
            page: UNITS_FORM_PAGE
        });
    }

    handleSelectUnitAction(key, value){
        if (key === 'edit'){
            let unit = this.props.units[value];
            this.setState({
                unitToEdit: unit,
                page: UNITS_FORM_PAGE
            });
        }else if(key === 'delete'){
            if(confirm(`Are you sure you want to delete this unit '${this.props.units[value].unitName}'?`)){
                let propertyId = this.props.units[value].propertyId;
                this.props.showLoading(true);
                this.props.deleteUnit(propertyId, value);
            }
        }
     }

     getPaymentMethod(shortcodeType, shortcode, tillNumber){
         let displayPaymentMethod = ""
        if (shortcodeType===TILL_NUMBER){
            displayPaymentMethod = `Till No: ${tillNumber}`
        } else if(shortcodeType===PAYBILL){
            displayPaymentMethod = `Paybill No. ${shortcode}`
        }
        return displayPaymentMethod
    }

    handleClosePropertyForm = () => {
        this.setState({
            page: this.props.tab === 'properties' ? PROPERTIES_PAGE :  UNITS_PAGE,
            propertyToEdit: null
        });
    }

    handleCloseUnitForm = () => {
        this.setState({
            page: this.props.tab === 'properties' ? PROPERTIES_PAGE :  UNITS_PAGE,
            unitToEdit: null
        });
    }

    handleVacantUnits = async (checked) => {
        this.setState({ isVacantUnitsChecked: checked });

        let allUnits = this.props.units;
        let selectedUnits = [];

        for (let unit of Object.values(allUnits)) {
            if (checked) {
                if (unit.occupied === false && unit.propertyId === this.state.propertyId) {
                    selectedUnits.push(unit);
                }
            } else {
                if (unit.propertyId === this.state.propertyId) {
                    selectedUnits.push(unit);
                }
            }
        }
        selectedUnits = this.getUnitsOrder(selectedUnits); // ordered selected units
        let selectedUnitsPage = this.state.unitId !== "" && this.props.units && this.props.units[this.state.unitId] ? [this.props.units[this.state.unitId]] : selectedUnits;
        allUnits = selectedUnits.length;

        this.setState({
            selectedUnits,
            selectedUnitsPage,
        });
    }

    handleFilterModalDismiss = () =>{
        this.setState({page: this.props.tab === 'properties' ? PROPERTIES_PAGE :  UNITS_PAGE});
    }

    renderFilters(){
        return (
            <IonModal isOpen={this.state.page === PAGE_FILTERS} onDidDismiss={this.handleFilterModalDismiss}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Filters</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                onClick={this.handleFilterModalDismiss}
                            >Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <div className='d-flex justify-content-center'>
                    <IonList style={{maxWidth: '350px'}}>
                    <IonItem>
                        <IonCheckbox
                            name="vacant"
                            id="vacant"
                            labelPlacement="end"
                            checked={this.state.isVacantUnitsChecked}
                            onIonChange={(e) => this.handleVacantUnits(e.detail.checked)}
                        >
                            Show vacant units
                        </IonCheckbox>
                    </IonItem>
                </IonList>
                </div>
                </IonContent>
            </IonModal>
        )
    }

    renderUnitsPage(){
        return (
            <React.Fragment>
                <IonHeader className='ion-no-border'>
                <Row className='mx-1 px-md-3 my-2'>
                    <Col xs={12} lg={6} className=''>
                        <IonSelect
                            type="select"
                            name="select-property"
                            interface="popover"
                            id="propertyFilter"
                            fill="solid"
                            className="filter-tenants"
                            onIonChange={this.handleSelectProperty.bind(this)}
                            value={this.state.propertyId}
                        >
                            <IonCustomPropertySelect propertiesArray={this.props.properties}/>
                        </IonSelect>
                        </Col>

                    <Col className="mt-1" xs={10} lg={5}>
                        <IonSelect
                            type="select"
                            name="select-unit"
                            id="Unit"
                            interface="popover"
                            fill="solid"
                            onIonChange={this.handleSelectUnit.bind(this)}
                            value={this.state.unitId}
                        >
                            <IonSelectOption key={""} value="">All Units</IonSelectOption>
                            {this.state.propertyId == ""?
                                <IonSelectOption>Please First Select a Property ...</IonSelectOption> :
                                _.map(Object.keys(this.props.properties[this.state.propertyId]["units"]), (unit, index) => (
                                    <IonSelectOption key={unit} value={unit}>
                                        {this.props.units[unit].unitName}
                                    </IonSelectOption>
                            ))}
                        </IonSelect>
                    </Col>
                    <div className='mx-0 my-2 pt-1 rounded'
                        style={{width:'55px', backgroundColor: colorTheme["primary"]["25"], color: colorTheme["primary"]["800"]}}>
                        <span >
                            <IonIcon onClick={ () => { this.setState({page: PAGE_FILTERS}) }}
                                size="large" aria-hidden="true"
                                id="vacant-units-filter"
                            icon={optionsOutline}
                            />
                        </span>
                    </div>
                    </Row>
                </IonHeader>
                <div style={{margin: 0, padding: 0}}>
                    <IonList id="units-ion-list-descriptions" style={{margin: 0, padding: 0}}>
                    {(this.state.selectedUnitsPage && this.state.selectedUnitsPage.length > 0 && this.state.selectedUnitsPage.map((unit, index) => {
                        return (
                        <UnitsListItem
                            key={unit.unitId}
                            unitId={unit.unitId}
                            unit={unit}
                            propertyName={this.props.properties[unit.propertyId]?.propertyName}
                            unitName={unit.unitName}
                            occupied={unit.occupied}
                            rentAmount={unit.rentAmount}
                            taxRate={unit.taxRate}
                            showDetails={false}
                            userAllPerms={this.state.userAllPerms}
                            currency={!_.isEmpty(this.props.currency)? this.props.currency.customerCurrency: ""}
                            handleUnitAction={this.handleSelectUnitAction.bind(this)}
                        />
                        )
                    }))}
                    </IonList>
                </div>

            </React.Fragment>
        )
    }

    renderPropertiesPage(){
        let summary = getPropertiesSummary([], {});
        if(this.state.page == PROPERTIES_PAGE){
            summary = this.state.propertiesSummary;
        }else{
            summary = this.state.singlePropertySummary;
        }
        return (
            <React.Fragment>
                <IonHeader className='ion-no-border'>
                    <Row className='mx-2 mt-2 pb-1 pb-2 mb-2 border-bottom'>
                        <Col xs={12} sm={4} className="mb-2">
                            <PropertiesSummaryCard
                                header={"Total Properties"}
                                body={Object.keys(this.props.properties).length}
                                footer={""}
                            />
                        </Col>
                        <Col xs={6} sm={4}>
                            <PropertiesSummaryCard
                                header={"Total Units"}
                                body={summary.totalUnits}
                                footer={""}
                            />
                        </Col>
                        <Col xs={6} sm={4}>
                            <PropertiesSummaryCard
                                header={"Total Vacancies"}
                                body={summary.vacancies}
                                footer={""}
                            />
                        </Col>
                    </Row>
                </IonHeader>
                <div style={{margin: 0, padding: 0}}>
                    <IonList id='ion-list-descriptions' style={{margin: 0, padding: 0}}>
                    {(this.state.selectedPropertiesData.map((property, index) => {
                        return (
                        <PropertyListItem
                            key={property.propertyId}
                            property={property}
                            propertyId={property.propertyId}
                            currency={!_.isEmpty(this.props.currency)? this.props.currency.customerCurrency: ""}
                            showDetails={false}
                            paymentMethod={this.getPaymentMethod(property.mpesaShortcodeType,property.mpesaShortcode, property.tillNumber )}
                            handlePropertyAction={this.handleSelectPropertyAction.bind(this)}
                            userAllPerms={this.state.userAllPerms}
                        />
                        )
                    }))}
                    </IonList>
                </div>

            </React.Fragment>
        )
    }

    renderPropertiesForm(){
        return (
            <IonModal isOpen={this.state.page === PROPERTIES_FORM_PAGE} onDidDismiss={this.handleClosePropertyForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Properties Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleClosePropertyForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <PropertyForm
                        property={this.state.propertyToEdit}
                    />
                </IonContent>
            </IonModal>

        );
    }

    renderUnitsForm(){
        return (
            <IonModal isOpen={this.state.page === UNITS_FORM_PAGE} onDidDismiss={this.handleCloseUnitForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Units Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleCloseUnitForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <UnitsForm
                        unit={this.state.unitToEdit}
                    />
                </IonContent>
            </IonModal>

        );
    }

    render() {
        return (
          <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>{this.props.tab === PROPERTIES_PAGE ? "Properties" : "Units"}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
              <div>
                    {this.state.page === PROPERTIES_PAGE && this.renderPropertiesPage()}

                    {this.state.page === UNITS_PAGE && this.renderUnitsPage()}

                    {/* render Modals */}

                    {this.state.page === PROPERTIES_FORM_PAGE && this.renderPropertiesForm()}

                    {this.state.page === UNITS_FORM_PAGE && this.renderUnitsForm()}

                    {this.renderFilters()}
              </div>
            </IonContent>
            <IonFab id="properties-ion-fab" className='ion-fab' slot="fixed" vertical="bottom" horizontal="end">
                <IonFabButton aria-label="Actions">
                    <IonIcon icon={add} />
                </IonFabButton>
                <IonFabList side="top">
                    {this.state.page === PROPERTIES_PAGE && this.state.userAllPerms.property && (<IonFabButton
                        onClick={() => this.setState({page: PROPERTIES_FORM_PAGE})}
                        data-desc="Add New Property"
                        id="property-page-form-ion-fab-icon"
                    >
                        <IonIcon icon={business}></IonIcon>
                    </IonFabButton>)}
                    {this.state.userAllPerms.unit &&
                    <IonFabButton
                        onClick={() => this.setState({page: UNITS_FORM_PAGE})}
                        data-desc="Add New Unit"
                        id="property-page-unit-form-ion-fab-icon"
                    >
                        <IonIcon icon={home}></IonIcon>
                    </IonFabButton>
                    }

                </IonFabList>
                </IonFab>
          </IonPage>
        );
      }

}
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Properties));